import {
  PLATFORM_SUPPORT_DECLINED_KEY,
  readSupportedTenantSession,
} from './supportedTenantsSession';

export { PLATFORM_SUPPORT_DECLINED_KEY };

export function platformSupportDeclinedTenant() {
  try {
    return sessionStorage.getItem(PLATFORM_SUPPORT_DECLINED_KEY) || '';
  } catch {
    return '';
  }
}

/**
 * A superadmin whose claim tenant has no active membership must enter support
 * context before tenant operations. Leaving the session records a decline so
 * the next render does not open it again.
 */
export function shouldEnterPlatformSupport({
  role,
  tenantId,
  membershipStatus,
  dealerActive = false,
  supportTenantId = readSupportedTenantSession()?.tenantId || '',
  declinedTenantId = platformSupportDeclinedTenant(),
} = {}) {
  if (dealerActive) return false;
  if (String(role || '') !== 'superadmin') return false;
  const id = String(tenantId || '').trim();
  if (!id) return false;
  if (String(supportTenantId || '').trim()) return false;
  if (String(declinedTenantId || '').trim() === id) return false;
  return String(membershipStatus || '').toLowerCase() !== 'active';
}

/**
 * An active membership is the normal grant. A support session for that same
 * tenant is the automatic workaround and should close.
 */
export function activeMembershipSupersedesSupport({
  supportTenantId,
  memberships,
} = {}) {
  const id = String(supportTenantId || '').trim();
  if (!id) return false;
  return (memberships || []).some((item) => (
    String(item?.tenantId || '').trim() === id
    && String(item?.status || '').toLowerCase() === 'active'
  ));
}
